import { RouteComponentProps } from '@reach/router'

const Orders = (props: RouteComponentProps) => <h1>Orders</h1>

export default Orders
